var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","loading":_vm.loading,"disabled":_vm.loading}},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":_vm.width,"height":_vm.height,"loading":"lazy","src":_vm.source},on:{"load":_vm.iframeLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }